<template>
    <gold-amount v-if="currency === 'Coppers'" :amount="amount"/>
    <span v-else-if="iconAvailable">
        {{ amount }}
        <span class="icon-wrapper">
           <img class="image is-16x16" :src="icon" :alt="currency">
        </span>
    </span>
    <span v-else>
        {{ amount }} {{currency}}
    </span>
</template>

<script>
    import GoldAmount from "@/components/GoldAmount";
    import Currencies from "@/currencies"


    export default {
        name: 'CurrencyAmount',
        components: {
            GoldAmount
        },
        props: {
            amount: {
                required: true
            },
            currency: {
                required: true
            }
        },
        computed: {
            iconAvailable() {
                return this.currency in Currencies.currencyIcons;
            },
            icon() {
                return Currencies.currencyIcons[this.currency];
            }
        }
    }
</script>

<style scoped>
    span {
        display: inline-flex;
    }
    .icon-wrapper {
        width: 20px;
        height: 20px;
        align-items: center;
        justify-content: center;
    }
    img {
    }
</style>
